import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { LanguagesService } from './languages.service';
import { GdprComponent } from '../components/gdpr/gdpr.component';

@Injectable()
export class ModalGdprService {
  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
    private languagesService: LanguagesService) { }

  confirm(): Observable<boolean> {

    this.bsModalRef = this.bsModalService.show(GdprComponent, { class: "modal-lg" });

    return new Observable<boolean>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((isAccepted: boolean) => {
        observer.next(this.bsModalRef.content.isAccepted);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }

}